import React from "react";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";
import { useFormContext } from "@/providers";

export const ExtraService = () => {
  const { errors, setValue, watch, fieldRefs } = useFormContext();

  const extra_service = watch("extra_service");

  const handleInputChangeOne = (index, field, value) => {
    const updatedExtraServicePrices = [...extra_service];
    updatedExtraServicePrices[index][field] = value;
    setValue("extra_service", updatedExtraServicePrices);
  };

  // const handlePlusClickOne = (e) => {
  //     e.preventDefault();
  //     setValue('extra_service', [
  //         ...extra_service,
  //         { name: "", price: "", type: "", quantity: "" },
  //     ]);
  // };
  const handleMinusClickOne = (index) => {
    if (extra_service.length > 1) {
      const newExtraServicePrices = [...extra_service];
      newExtraServicePrices.splice(index, 1);
      setValue("extra_service", newExtraServicePrices);
    } else {
      setValue("extra_services", 0);
    }
  };
  return (
    <>
      {extra_service &&
        extra_service?.map((service, index) => (
          <React.Fragment key={index}>
            <div className="text-left md:col-span-6">
              <label>Name</label>
              <div className="flex items-center gap-4 px-3 py-3 border rounded-md border-input">
                <i className="fal fa-tag" />
                <input
                  type="text"
                  placeholder="Name"
                  value={service.name}
                  name="name"
                  ref={(el) =>
                    (fieldRefs.current[`extra_service.${index}.name`] = el)
                  }
                  onChange={(e) =>
                    handleInputChangeOne(index, "name", e.target.value)
                  }
                />
              </div>
              {errors?.extra_service?.[index]?.name && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="text-left md:col-span-6">
              <label>Price (N)</label>
              <div className="flex items-center gap-4 px-3 py-3 border rounded-md border-input">
                <i className="fal fa-dollar-sign" />
                <input
                  type="number"
                  placeholder="Price"
                  value={service.price}
                  name="price"
                  ref={(el) =>
                    (fieldRefs.current[`extra_service.${index}.price`] = el)
                  }
                  onChange={(e) =>
                    handleInputChangeOne(index, "price", e.target.value)
                  }
                />
              </div>
              {errors?.extra_service?.[index]?.price && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="text-left md:col-span-6">
              <label>Type</label>
              <select
                data-placeholder="Type"
                className="flex items-center w-full gap-4 px-3 py-3 border rounded-md border-input"
                value={service.type}
                name="type"
                ref={(el) =>
                  (fieldRefs.current[`extra_service.${index}.type`] = el)
                }
                onChange={(e) =>
                  handleInputChangeOne(index, "type", e.target.value)
                }
              >
                <option value="">Type</option>
                <option value="Single Fee">Single Fee</option>
                <option value="Per Night">Per Night</option>
                <option value="Per Guest">Per Guest</option>
                <option value="Per Night Per Guest">Per Night Per Guest</option>
              </select>
              {errors?.extra_service?.[index]?.type && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="text-left md:col-span-6">
              <label className="inline-flex items-center">
                Quantity Available
                <MdQuestionMark
                  onClick={() =>
                    Swal.fire({
                      text: "How many units are available of the Extra Service you are currently entering? For example, if your extra service is a fully stocked refrigerator and you are only willing to stock it one time, enter quantity 1.",
                      icon: "question",
                    })
                  }
                  style={{
                    color: "#8ec639",
                    cursor: "pointer",
                  }}
                />
              </label>
              <div className="flex items-center gap-4 px-3 py-3 border rounded-md border-input">
                <i className="fal fa-hashtag"></i>
                <input
                  type="number"
                  placeholder="Quantity"
                  name="quantity"
                  ref={(el) =>
                    (fieldRefs.current[`extra_service.${index}.quantity`] = el)
                  }
                  value={service.quantity}
                  onChange={(e) =>
                    handleInputChangeOne(index, "quantity", e.target.value)
                  }
                />
              </div>
              {errors?.extra_service?.[index]?.quantity && (
                <p style={{ color: "red" }}>Required</p>
              )}
            </div>

            <div className="flex items-start justify-start md:col-span-12">
              {extra_service?.length > 1 && (
                <button
                  className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                  onClick={() => handleMinusClickOne(index)}
                >
                  Remove Service
                </button>
              )}
            </div>
          </React.Fragment>
        ))}

      {/* <div className="flex items-end justify-end text-left md:col-span-12">
                <button
                    onClick={handlePlusClickOne}
                    className="border border-[#3b4249] font-medium bg-[#8ec639] rounded-md text-white px-8 py-3"
                >
                    Add Service
                </button>
            </div> */}
    </>
  );
};
